import React from 'react';
import PropTypes from 'prop-types';
import { QRCodeSVG } from 'qrcode.react';
import { CoinIcon } from '../../../model/icons';
import { POINT_TYPE_LABELS, POINT_STATUS } from '../../../../../hooks/useFairEditState';
import { pointStatusChip } from './fairModel';

// Карточка точки ярмарки (.fr-point): QR, название, цена, статус, тип, заработок. Клик открывает модалку точки.
// React.memo + стабильные onOpen/onShowTx: стейт родителя (модалки) не перерисовывает сетку QR.
const PointCard = React.memo(function PointCard({ point, index, qrBaseUrl, onOpen, onShowTx }) {
    const needs = point.status === POINT_STATUS.PENDING;
    const qrValue = qrBaseUrl ? `${qrBaseUrl}${point.code}` : point.code;
    const chip = pointStatusChip(point.status);
    const open = () => onOpen(point);

    return (
        <div className={`fr-point${needs ? ' needs' : ''}`} role="button" tabIndex={0} onClick={open} onKeyDown={(e) => { if (e.key === 'Enter') open(); }}>
            <div className="fr-phdr">
                <div className="fr-ptags">
                    <span className={chip.cls}>{chip.label}</span>
                    {point.type && <span className={`fr-chip-type ty-${point.type}`}>{POINT_TYPE_LABELS[point.type]}</span>}
                </div>
                <div className="fr-pacts">
                    {onShowTx && (
                        <button type="button" className="btn btn-ghost fr-pbtn" onClick={(e) => { e.stopPropagation(); onShowTx(point); }}>Продажи</button>
                    )}
                </div>
            </div>
            <div className="fr-pbody">
                <div className="fr-qr">
                    {point.code && <QRCodeSVG value={qrValue} size={52} level="M" />}
                    <span className="fr-pnum">{index + 1}</span>
                </div>
                <div className="fr-pinfo">
                    <div className="fr-ptop">
                        <div className="fr-pname">{point.name || 'Без названия'}</div>
                        {point.price ? <div className="fr-pprice">{point.price} <CoinIcon /></div> : null}
                    </div>
                    <div className="fr-pspent"><CoinIcon />Заработано: {point.spent || 0}</div>
                </div>
            </div>
        </div>
    );
});

PointCard.propTypes = {
    point: PropTypes.object.isRequired,
    index: PropTypes.number.isRequired,
    qrBaseUrl: PropTypes.string,
    onOpen: PropTypes.func.isRequired,
    onShowTx: PropTypes.func
};

PointCard.defaultProps = { qrBaseUrl: null, onShowTx: null };

export default PointCard;
